"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const rebass_1 = require("rebass");
const styled_components_1 = __importDefault(require("styled-components"));
const useClickOutside_1 = __importDefault(require("../../hooks/useClickOutside"));
function default_1({ children, actions = [], width }) {
    const [visible, setVisible] = react_1.useState(false);
    const ref = react_1.useRef(null);
    useClickOutside_1.default(ref, () => setVisible(false));
    return (react_1.default.createElement(Wrapper, { onClick: (e) => {
            setVisible(true);
        } },
        children,
        visible && (react_1.default.createElement(ActionMenu, { ref: ref, width: width, variant: "action_menu" }, actions.map((action, idx) => (react_1.default.createElement(ActionItem, { p: 2, key: idx, alignItems: "center", onClick: (e) => {
                e.stopPropagation();
                setVisible(false);
                action.onClick();
            } },
            react_1.default.createElement(rebass_1.Flex, { width: "auto", justifyContent: "flex-end", mr: 2 }, action.icon),
            action.title)))))));
}
exports.default = default_1;
const Wrapper = styled_components_1.default(rebass_1.Box) `
    position: relative;
`;
const ActionMenu = styled_components_1.default(rebass_1.Box) `
    position: absolute;
    right: 0;
    top: 100%;
    border-radius: 10px;
    min-width: 100px;
    border: 1px solid #eee;
    padding: 5px;
`;
const ActionItem = styled_components_1.default(rebass_1.Flex) `
    font-weight: 500;
    border-radius: 5px;
    :hover {
        cursor: pointer;
        background: rgba(100, 100, 100, 0.3);
    }
`;
//# sourceMappingURL=index.js.map